import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import BooleanRen from "csi/heading/Boolean";
import Spec, { QuerySpec } from "csi/core/Spec";
import declare from "dojo/_base/declare";

const ThemeBOMSysIDRenderer = declare(BooleanRen, {
	/**
	 * @override
	 * Disable filtering
	 */
	getQuerySpec(ctx: Context, h: Heading, spec: Spec): QuerySpec {
		const qs = this.inherited<QuerySpec>(arguments);
		qs.notFilterable = true;
		return qs;
	},

	/**
	 * @override
	 * Return true if PartMaterial.ThemeBOMSysID is initialized
	 */
	_getValue(ctx: Context, h: Heading) {
		return !!ctx.getNode().ThemeBOMSysID;
	},

	/**
	 * @override
	 * Format at Boolean instead of String
	 */
	_getCSS(type: String, format: String) {
		return "attrBoolean";
	},
});

export = ThemeBOMSysIDRenderer;
